import generateModel from './model';
import { generateOptions, optionsChanged } from './options';

const CatalogMap = {
    generateModel,
    generateOptions,
    optionsChanged
}

export default CatalogMap;
